import { useMemo } from 'react';
import SiteLayout from '@/components/feature/SiteLayout';
import { useSeo } from '@/hooks/useSeo';
import { platforms } from '@/mocks/platforms';
import { faqs } from '@/mocks/faqs';
import HeroSection from './components/HeroSection';
import OverviewSections from './components/OverviewSections';
import ContentSections from './components/ContentSections';
import SocialSections from './components/SocialSections';

const SITE_URL = 'https://luosai123.cn';

export default function Home() {
  const jsonLd = useMemo(() => {
    const featured = [...platforms].sort((a, b) => b.heat - a.heat).slice(0, 6);
    return [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '爆料网上',
        url: `${SITE_URL}/`,
        description: '聚合全网热门爆料网站与论坛社区的导航门户。',
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: `${SITE_URL}/directory?q={search_term_string}`,
          },
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: '爆料网上',
        url: `${SITE_URL}/`,
        description: '爆料平台与论坛社区导航门户，提供入口整理与投稿指南。',
        email: 'hello@baoliao-online.example.com',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: '本周热度榜 · 最常被用到的爆料平台',
        itemListElement: featured.map((item, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: item.name,
          url: item.url,
        })),
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.slice(0, 6).map((item) => ({
          '@type': 'Question',
          name: item.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: item.answer,
          },
        })),
      },
    ];
  }, []);

  useSeo({
    title: '爆料网上 - 爆料平台导航｜爆料网站大全与论坛社区汇总',
    description:
      '爆料网上聚合全网热门爆料平台与论坛社区，整理最新可用的爆料发布入口、讨论版块与投稿指南，帮你快速定位靠谱的爆料渠道与求证方向。',
    keywords: '爆料网上,爆料平台导航,爆料网站大全,爆料论坛,爆料社区,爆料入口',
    path: '/',
    jsonLd,
  });

  return (
    <SiteLayout>
      <HeroSection />
      <OverviewSections />
      <ContentSections />
      <SocialSections />
    </SiteLayout>
  );
}